import { JsonObject, JsonProperty } from 'json2typescript';
import { OperativeWithdrawalRequestInterface } from '../interfaces/withdrawal.interface';

@JsonObject('OperativeWithdrawalRequest')
export class OperativeWithdrawalRequest
  implements OperativeWithdrawalRequestInterface
{
  @JsonProperty('IsTotal', Boolean, true)
  isTotal: boolean = false;

  @JsonProperty('Amount', Number, true)
  amount: number = undefined;

  @JsonProperty('CashRefund', Boolean, true)
  cashRefund: boolean = true;

  @JsonProperty('Currency', String, true)
  currency: string;

  @JsonProperty('SmsValidation', Boolean, true)
  smsValidation: boolean = undefined;

  @JsonProperty('Type', String, true)
  type: string = undefined;

  @JsonProperty('PortfolioIdDestination', String, true)
  portfolioIdDestination: string = undefined;
}
